import React, { FC, useEffect } from "react";

import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Grid } from "@mui/material";

import { FormPanel } from "@/components/organisms";

import { CustomerCardFormType } from "../../../formType";
import CustomerCommunication from "../components/CustomerCommunication/CustomerCommunication";
import SpreadPanel from "../components/SpreadPanel/SpreadPanel";
import DriverLicense from "./components/DriverLicense/DriverLicense";
import Identity from "./components/Identity/Identity";
import PersonalInfo from "./components/PersonalInfo/PersonalInfo";

const PhysicalDetails: FC = () => {
    const { t } = useTranslation();

    const { trigger, watch } = useFormContext<CustomerCardFormType>();

    const idNumber = watch("identity.idNumber");
    const validFrom = watch("identity.validFrom");
    const validTo = watch("identity.validTo");

    useEffect(() => {
        if (!idNumber) {
            trigger("identity.validFrom");
            trigger("identity.validTo");
        }
    }, [idNumber]);

    useEffect(() => {
        if (!validFrom) {
            trigger("identity.idNumber");
            trigger("identity.validTo");
        }
    }, [validFrom]);

    useEffect(() => {
        if (!validTo) {
            trigger("identity.idNumber");
            trigger("identity.validFrom");
        }
    }, [validTo]);

    return (
        <Grid container columnSpacing={{ sm: 2, md: 6 }}>
            <Grid item container xs={12} sm={6} alignSelf="start" direction="column" rowSpacing={0}>
                <Grid item xs={12}>
                    <FormPanel title={t("CustomerDetails.General.PersonalInfo")} mode="edit">
                        <PersonalInfo />
                    </FormPanel>
                </Grid>
                <Grid item xs={12}>
                    <FormPanel title={t("CustomerDetails.General.Communication")} mode="edit">
                        <CustomerCommunication />
                    </FormPanel>
                </Grid>
            </Grid>
            <Grid item container xs={12} sm={6} alignSelf="start" direction="column" rowSpacing={0}>
                <Grid item xs={12}>
                    <FormPanel title={t("CustomerDetails.General.IdentityCard")} mode="edit">
                        <Identity />
                    </FormPanel>
                </Grid>
                <Grid item xs={12}>
                    <FormPanel title={t("CustomerDetails.General.DriverLicense")} mode="edit">
                        <DriverLicense />
                    </FormPanel>
                </Grid>
                <Grid item xs={12}>
                    <SpreadPanel />
                </Grid>
            </Grid>
        </Grid>
    );
};

export default PhysicalDetails;
